import { Base } from "ui/Scripts/source/framework/base";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { IRecordEducationListItem, RecordEducationListItem } from "../recordEducation/recordEducationListItem";
import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { IRecordEditItem, RecordEditItem } from "./recordEditItem";
import { IRecordFamiliarizationListItem, RecordFamiliarizationListItem } from "ui/Scripts/source/models/recordFamiliarization/recordFamiliarizationListItem";
import { RecordEditItemFamiliarization } from "./recordEditItemFamiliarization";
import { RecordEditItemFurtherEducation } from "./recordEditItemFurtherEducation";
import { RecordEditItemQualification } from "./recordEditItemQualification";
import { IRecordFurtherEducationGroupNode, RecordFurtherEducationGroupNode } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordFurtherEducationGroupNode";

export interface IRecordEdit {
    record: IRecordEditItem;
    canReadUsers: boolean;
    canEditUsers: boolean;
    canClearUnit: boolean;
    canArchiveAndRemove: boolean;
    isPartnerCompanyRecord: boolean;
    units: IIdTitleNode[];
    attachments: IFileAttachment[];
    jobTitles: string[];
    familiarizations: IRecordFamiliarizationListItem[];
    basicEducations: IRecordEducationListItem[];
    furtherEducationGroups: IRecordFurtherEducationGroupNode[];
    taskType: ITaskEditTypeItem;
    transferredPropertyTypes: string[];
    familiarizationTrainers: string[];
    workShiftNames: string[];
}

export class RecordEdit implements IRecordEdit {
    record: RecordEditItem;
    canReadUsers: boolean;
    canEditUsers: boolean;
    canClearUnit: boolean;
    canArchiveAndRemove: boolean;
    isPartnerCompanyRecord: boolean;
    units: IdTitleNode[];
    attachments: FileAttachment[];
    jobTitles: string[];
    familiarizations: RecordFamiliarizationListItem[];
    basicEducations: RecordEducationListItem[];
    furtherEducationGroups: RecordFurtherEducationGroupNode[];
    taskType: TaskEditTypeItem;
    transferredPropertyTypes: string[];
    familiarizationTrainers: string[];
    workShiftNames: string[];

    constructor();
    constructor(obj: IRecordEdit);
    constructor(obj?: any) {
        this.record = new RecordEditItem(obj ? obj.record : null);
        this.canReadUsers = obj && obj.canReadUsers || false;
        this.canEditUsers = obj && obj.canEditUsers || false;
        this.canClearUnit = obj && obj.canClearUnit || false;
        this.canArchiveAndRemove = obj && obj.canArchiveAndRemove || false;
        this.isPartnerCompanyRecord = obj && obj.isPartnerCompanyRecord || false;
        this.units = Base.getTypedArray(obj ? obj.units : null, IdTitleNode);
        this.attachments = Base.getTypedArray(obj ? obj.attachments : null, FileAttachment);
        this.jobTitles = obj && obj.jobTitles || [];
        this.familiarizations = Base.getTypedArray(obj ? obj.familiarizations : null, RecordFamiliarizationListItem);
        this.basicEducations = Base.getTypedArray(obj ? obj.basicEducations : null, RecordEducationListItem);
        this.furtherEducationGroups = Base.getTypedArray(obj ? obj.furtherEducationGroups : null, RecordFurtherEducationGroupNode);
        this.taskType = obj?.taskType ? new TaskEditTypeItem(obj.taskType) : null;
        this.transferredPropertyTypes = obj && obj.transferredPropertyTypes || [];
        this.familiarizationTrainers = obj && obj.familiarizationTrainers || [];
        this.workShiftNames = obj && obj.workShiftNames || [];
        this.record.initializeSheetDataRowsRows(this.taskType);
        RecordEditItemFamiliarization.setFamiliarizationCodes(this.record.familiarizations, this.familiarizations);
        RecordEditItemFurtherEducation.setFurtherEducationCodes(this.record.furtherEducations, this.furtherEducationGroups);
        RecordEditItemQualification.setFurtherEducationCodes(this.record.qualifications, this.furtherEducationGroups, this.record.furtherEducations);
        RecordEditItemFurtherEducation.setQaulificationsValidity(this.record.furtherEducations, this.record.qualifications);
    }
}